export default __webpack_public_path__ + "static/media/blue-tick-image.4b582bc3.webp";